<template>
  <div class="network-error-page" role="alert" aria-live="polite">
    <div class="content" role="main" tabindex="0">
      <span class="network-icon material-symbols-outlined" aria-hidden="true" role="img">
        signal_wifi_connected_no_internet_4
      </span>

      <h1 class="title">Falha na conexão</h1>
      <p class="message">
        Não foi possível conectar ao servidor.<br />
        Verifique sua internet ou tente novamente mais tarde.
      </p>

      <div class="button-group">
        <NuxtLink to="/" class="btn-primary" aria-label="Voltar para a página inicial">
          Voltar ao Início
        </NuxtLink>

        <button
          type="button"
          class="btn-secondary"
          @click="recarregarPagina"
          aria-label="Recarregar a página"
        >
          Recarregar Página
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// Função que recarrega a página
function recarregarPagina() {
  window.location.reload();
}
</script>

<style scoped>

html, body, #__nuxt, .network-error-page {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: rgba(11, 69, 113, 0.1);
  font-family: Inter, "Segoe UI", Roboto, Arial, sans-serif;
  color: rgba(11, 69, 113, 0.85);
}

.network-error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem;
  text-align: center;
  user-select: none;
}

.content {
  max-width: 420px;
  background: rgba(11, 69, 113, 0.07);
  padding: 3rem 2.5rem;
  border-radius: var(--funarpen-radius);
  box-shadow:
    0 6px 16px rgba(11, 69, 113, 0.15),
    0 12px 24px rgba(11, 69, 113, 0.1);
  outline: none;
}

.network-icon {
  display: block;
  font-size: 96px;
  color: rgba(11, 69, 113, 0.7);
  margin: 0 auto 1.75rem;
  animation: smooth-pulse 2s ease-in-out infinite;
}

@keyframes smooth-pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

.title {
  font-weight: 700;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: rgba(11, 69, 113, 0.9);
}

.message {
  font-weight: 500;
  font-size: 1.125rem;
  margin-bottom: 2.5rem;
  line-height: 1.6;
  color: rgba(11, 69, 113, 0.75);
}

.button-group {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.btn-primary,
.btn-secondary {
  display: inline-block;
  padding: 0.8rem 2.5rem;
  font-weight: 700;
  font-size: 1.125rem;
  border-radius: var(--funarpen-radius);
  text-decoration: none;
  user-select: none;
  transition: background 0.3s ease, box-shadow 0.3s ease;
}

.btn-primary {
  color: white;
  background: rgba(11, 69, 113, 0.7);
  box-shadow: 0 10px 25px rgba(11, 69, 113, 0.4);
}

.btn-primary:hover,
.btn-primary:focus-visible {
  background: rgba(11, 69, 113, 0.9);
  box-shadow: 0 14px 40px rgba(11, 69, 113, 0.6);
  outline: none;
}

.btn-secondary {
  color: rgba(11, 69, 113, 0.85);
  background: rgba(11, 69, 113, 0.15);
  box-shadow: 0 4px 12px rgba(11, 69, 113, 0.2);
  border: none;
  cursor: pointer;
}

.btn-secondary:hover,
.btn-secondary:focus-visible {
  background: rgba(11, 69, 113, 0.25);
  box-shadow: 0 6px 20px rgba(11, 69, 113, 0.3);
  outline: none;
}

@media (max-width: 480px) {
  .content {
    padding: 2.5rem 1.5rem;
  }
  .title {
    font-size: 2rem;
  }
  .message {
    font-size: 1rem;
  }
}
</style>
